module.exports = require("@ember/object/observers");